import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Confetti = () => {
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        const colors = ['#FFD700', '#FF007F', '#00FFFF', '#39FF14', '#FF3B30', '#FFFFFF'];
        const newParticles = Array.from({ length: 100 }, (_, i) => ({
            id: i,
            x: Math.random() * 100,
            color: colors[Math.floor(Math.random() * colors.length)],
            delay: Math.random() * 0.5,
            duration: 2 + Math.random() * 2,
            size: 5 + Math.random() * 10,
            rotation: Math.random() * 360
        }));
        setParticles(newParticles);
    }, []);

    return (
        <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
            {particles.map((particle) => (
                <motion.div
                    key={particle.id}
                    className="absolute"
                    style={{
                        left: `${particle.x}%`,
                        top: -20,
                        width: particle.size,
                        height: particle.size,
                        backgroundColor: particle.color,
                        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
                    }}
                    initial={{ y: -20, rotate: 0, opacity: 1 }}
                    animate={{
                        y: window.innerHeight + 50,
                        rotate: particle.rotation + 720,
                        opacity: [1, 1, 0]
                    }}
                    transition={{
                        duration: particle.duration,
                        delay: particle.delay,
                        ease: "linear"
                    }}
                />
            ))}
        </div>
    );
};

export default Confetti;
